import { render, staticRenderFns } from "./SuppliersShow.vue?vue&type=template&id=78b0a984&"
import script from "./SuppliersShow.vue?vue&type=script&lang=js&"
export * from "./SuppliersShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports